<!-- Modal -->
<div
  class="modal fade"
  id="configurationsModal"
  tabindex="-1"
  aria-labelledby="configurationsModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg modal-dialog-centered" style="margin-top: -20vh;">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="configurationsModalLabel" style="font-weight: bold">
          Configurations
        </h5>
        <button 
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          (click)="closeModal()"
        ></button>
      </div>
      <div class="modal-body">
        <!-- Custom Alerts Section -->
        <div class="card">
          <div class="card-header text-left" style="font-weight: bold;">
            Custom Alerts
          </div>
          <div class="card-body">
            <!-- Control de rango -->
            <label for="rangeControl" class="form-label">This value, ranging from 50% to 100%, will set the consumption alert threshold percentage. An alert will be triggered when consumption exceeds this percentage.</label>
            <input 
              type="range" 
              class="form-range" 
              id="rangeControl" 
              min="50" 
              max="100" 
              [(ngModel)]="selectedValue" 
              (input)="updateValue($event)">

            <!-- Mostrar el valor seleccionado dinámicamente -->
            <p class="mt-2">Alert threshold set to: {{ selectedValue }}%</p>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
          (click)="closeModal()"
        >
          Close
        </button>
        <button
          type="button"
          class="btn btn-primary"
          data-bs-dismiss="modal"
          (click)="updateUserStatus()"
        >
          Save changes
        </button>
      </div>
    </div>
  </div>
</div>
